module.exports = __webpack_public_path__ + "img/logo.203f5f5a.png";